import type { JwtCredentials } from '../model/providers';
import { AUTH_STORAGE_KEY } from './constants';

let cachedRawCredentials: string | null | undefined;
let cachedCredentials: JwtCredentials | null = null;

function parseStoredCredentials(
  rawCredentials: string | null,
): JwtCredentials | null {
  if (rawCredentials === cachedRawCredentials) {
    return cachedCredentials;
  }

  cachedRawCredentials = rawCredentials;
  if (!rawCredentials) {
    cachedCredentials = null;
    return cachedCredentials;
  }

  try {
    cachedCredentials = JSON.parse(rawCredentials) as JwtCredentials | null;
  } catch {
    cachedCredentials = null;
  }
  return cachedCredentials;
}

function readStoredCredentials(): JwtCredentials | null {
  return parseStoredCredentials(localStorage.getItem(AUTH_STORAGE_KEY));
}

export { parseStoredCredentials, readStoredCredentials };
